module.exports = "https://activity.hdslb.com/blackboard/activity92636/img/fantan-card-poster.b9eaf6ce.png";